// ONE dynamic import, nothing static - see the header of ./bootstrap.ts for why (chunk churn).
// Adding a static import here puts that code and everything it reaches back into main, which
// every lazy chunk then imports, and a single lazy change renames the whole dist again.
import('./bootstrap').catch((err) => console.log(err));
